//main.jsx
import React, {useEffect} from 'react';
import {Outlet} from 'react-router-dom';
import HeaderContent from "./HeaderContent";
import FooterContent from "./FooterContent";
import {useSelector} from "react-redux";
import BlankLayout from "./BlankLayout";
import Loading from "../modal/Loading";
import AuthModal from "../modal/AuthModal";
import ExchangeNotifierBar from "../exchange/v1/ui/ExchangeNotifierBar";
import {selectIsAuthenticated, selectIsCheckingAuth} from "../../store/authSlice";


const Main = () => {
  const isAuth = useSelector(selectIsAuthenticated);
  const isChecking = useSelector(selectIsCheckingAuth);

  useEffect(() => {
    document.title = "USDSeller | Главная";
  }, []);
  if (isChecking) {
    return (
      <>
        <BlankLayout/>
        <AuthModal style={{display: "none"}}/>
        <Loading/>
      </>
    );
  }

  if (!isAuth) {
    return (
      <>
        <BlankLayout/>
        <AuthModal/>
      </>
    );
  }

  return (
    <div className="main-div-with-bg">
      <ExchangeNotifierBar/>

      <div className="layout">
        <HeaderContent/>

        <main className="content">
          <Outlet/>
        </main>

        <FooterContent/>
      </div>
    </div>
  );

};

export default Main;